import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import './AboutCategoriesList.scss';
import { Loader } from '../../components/Loader/Loader.jsx';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../config.js';
import { BackButton } from '../../components/BackButton/BackButton.jsx';
import { ModalMessage } from '../../components/ModalMessage/ModalMessage.jsx';
import { Logout } from '../../components/Logout/Logout.jsx';

export const AboutCategoriesList = () => {
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);

	const getCategories = async () => {
		setLoading(true);
		try {
			const { data: response } = await Axios.get(`${API_URL}/about`);
			// ordenar por `order` en backend o aquí
			const sorted = [...response.data].sort((a, b) => a.order - b.order);
			setCategories(sorted);
		} catch (error) {
			console.log(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getCategories();
	}, []);

	const deleteCategory = async (id) => {
		const confirm = window.confirm(
			'¿Estás seguro de que quieres eliminar la categoría (About)?'
		);
		if (!confirm) return;
		try {
			const { data: response } = await Axios.delete(
				`${API_URL}/about/${id}`
			);
			setMessage(response.message);
			getCategories();
		} catch (error) {
			console.log(error);
			setError(error.message);
		}
	};

	const handleSortUpdate = async (newOrder) => {
		const orderedIds = newOrder.map((item) => item._id);
		setCategories(newOrder);

		try {
			await Axios.patch(
				`${API_URL}/about/order`,
				{ orderedIds },
				{ headers: { 'Content-Type': 'application/json' } }
			);
			setMessage('Orden actualizado correctamente');
		} catch (error) {
			console.error('❌ Error al actualizar orden:', error);
			setError('Error al actualizar el orden de las categorías');
		}
	};

	return (
		<div className='AboutCategoriesList'>
			{loading && <Loader />}

			<div className='container'>
				<BackButton to='/dashboard' text='Dashboard' />
				<Logout />
				<br />
				<h3>CATEGORÍAS DE I.B.</h3>
				{message && (
					<ModalMessage
						type='success'
						message={message}
						onClose={() => setMessage(null)}
					/>
				)}
				{error && (
					<ModalMessage
						type='error'
						message={error}
						onClose={() => setError(null)}
					/>
				)}

				{categories.length === 0 ? (
					<h4>No hay categorías todavía</h4>
				) : (
					<ReactSortable
						list={categories}
						setList={setCategories}
						ghostClass='dropArea'
						handle='.dragHandle'
						filter='.ignoreDrag'
						preventOnFilter={true}
						onEnd={({ oldIndex, newIndex }) => {
							if (oldIndex !== newIndex) {
								const newList = [...categories];
								const [movedItem] = newList.splice(oldIndex, 1);
								newList.splice(newIndex, 0, movedItem);
								handleSortUpdate(newList);
							}
						}}
					>
						{categories.map((aboutCategory) => (
							<div
								className='aboutCategory dragHandle'
								key={aboutCategory._id}
							>
								<h4>{aboutCategory.title}</h4>
								<div className='btn-container'>
									<Link
										className='editButton'
										to={`/edit-aboutCategory/${aboutCategory._id}`}
									>
										<img
											src={require('../../assets/icons/editar.png')}
											alt='edit-icon'
											className='editIcon'
										/>
									</Link>
									<button
										className='deleteButton'
										onClick={() =>
											deleteCategory(aboutCategory._id)
										}
										aria-label={`Eliminar ${aboutCategory.title}`}
									>
										X
									</button>
								</div>
							</div>
						))}
					</ReactSortable>
				)}
			</div>
		</div>
	);
};
